// extracted by mini-css-extract-plugin
export default {"wrapper":"NumberInput_wrapper__tvcbe","input":"NumberInput_input__OonII","suffix":"NumberInput_suffix__a-EL4"};